import script from "./AssessmentRecommendations.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssessmentRecommendations.vue?vue&type=script&setup=true&lang=ts"

import "./AssessmentRecommendations.vue?vue&type=style&index=0&id=117d250d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117d250d"]])

export default __exports__